/** Эквайринг клуба доступен всем владельцам/админам. */
export function isClubAcquiringEmailAllowed(_email) {
  return true;
}
